import { useHabitReminders } from "@/features/habits/hooks/use-habit-reminders";

/**
 * Headless singleton that keeps habit reminders in sync with the platform's
 * notification backend. Mount once inside the PowerSync provider tree.
 */
export function ReminderScheduler() {
  useHabitReminders();
  return null;
}
